export const MIN_RATING = 0
export const MAX_RATING = 5
